/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetResourceAudienceForm,
  SetResourceAudienceForm$Outbound,
  SetResourceAudienceForm$outboundSchema,
} from "../components/setresourceaudienceform.js";

export type SetResourceAudienceSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type SetResourceAudienceRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  setResourceAudienceForm: SetResourceAudienceForm;
};

/** @internal */
export type SetResourceAudienceSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SetResourceAudienceSecurity$outboundSchema: z.ZodMiniType<
  SetResourceAudienceSecurity$Outbound,
  SetResourceAudienceSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function setResourceAudienceSecurityToJSON(
  setResourceAudienceSecurity: SetResourceAudienceSecurity,
): string {
  return JSON.stringify(
    SetResourceAudienceSecurity$outboundSchema.parse(
      setResourceAudienceSecurity,
    ),
  );
}

/** @internal */
export type SetResourceAudienceRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  SetResourceAudienceForm: SetResourceAudienceForm$Outbound;
};

/** @internal */
export const SetResourceAudienceRequest$outboundSchema: z.ZodMiniType<
  SetResourceAudienceRequest$Outbound,
  SetResourceAudienceRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    setResourceAudienceForm: SetResourceAudienceForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      setResourceAudienceForm: "SetResourceAudienceForm",
    });
  }),
);

export function setResourceAudienceRequestToJSON(
  setResourceAudienceRequest: SetResourceAudienceRequest,
): string {
  return JSON.stringify(
    SetResourceAudienceRequest$outboundSchema.parse(setResourceAudienceRequest),
  );
}
